import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

export const demandDetailFormDataSchema = z.object({
  capabilities: z.array(z.string()).nullable(),
  responsible: z.string().nullable(),
  referenceId: z.string().nullable(),
  competitiveBidding: z
    .object({
      deadline: z.date().min(new Date()).nullable(),
      maskBidding: z.object({
        enabled: z.boolean(),
      }),
    })
    .refine((data) => (data.maskBidding.enabled ? data.deadline : true), {
      path: ['deadline'],
      params: { i18n: 'widgets:DemandDetailWidget.competitiveBidding.errors.deadlineRequired' },
    })
    .nullable(),
});

export type DemandDetailFormData = z.infer<typeof demandDetailFormDataSchema>;

export const demandDetailFormDataDefault: DefaultValues<DemandDetailFormData> = {
  capabilities: [],
  competitiveBidding: {
    deadline: null,
    maskBidding: {
      enabled: false,
    },
  },
};
